import styled from "styled-components";
import { paddingTopBottom, colors, MOBILE_BREAKPOINT } from "@util/constants";

export const FormSectionWrapper = styled.section`
  ${paddingTopBottom.l}
  background-color: ${colors.lightGrey};

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    > div {
      padding-left: 16px;
      padding-right: 16px;
    }
  }
`;
